import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { CreateUserAuth } from "../create/formCreate";
import { EditUserAuth } from "../edit/formEdit";




export const ModalUserAuth = ({setopenMondal, isOpen, isEdit, data, createUser, reload, editUser}) => {

    const clearData = () => {
        setopenMondal(false)
        reload()
    }


    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} >
                        {isEdit? `Editar usuario`: `Crear usuario`}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        {
                            isEdit?
                            (<EditUserAuth data={data} clearData={clearData} edit={editUser}/>)
                            :
                            (<CreateUserAuth create={createUser} clearData={clearData}/>)
                        }
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}